class ProductGalleryEnhanced {
    constructor() {
        this.initializeGalleryClickToZoom();
    }

    initializeGalleryClickToZoom() {
        // Wait for custom elements to be defined
        customElements.whenDefined('product-gallery').then(() => {
            const galleries = document.querySelectorAll('product-gallery');

            galleries.forEach((gallery) => {
                const carousel = gallery.querySelector('.product-gallery__carousel');
                if (!carousel || gallery.hasAttribute('enhanced-clicks')) return;

                // Mark as enhanced to avoid duplicate initialization
                gallery.setAttribute('enhanced-clicks', 'true');

                // Override the click handler
                carousel.addEventListener(
                    'click',
                    (event) => {
                        // Check if clicking on an image (not a button or video)
                        const media = event.target.closest('.product-gallery__media');
                        if (!media) return;

                        // Skip if clicking on buttons or links
                        if (event.target.matches('button, a[href], button :scope, a[href] :scope')) {
                            return;
                        }

                        // Only handle image media types
                        if (media.getAttribute('data-media-type') !== 'image') {
                            return;
                        }

                        // Prevent the default carousel navigation behavior
                        event.stopImmediatePropagation();

                        // Dispatch lightbox open event
                        const imageIndex = Array.from(
                            carousel.querySelectorAll(
                                '.product-gallery__media[data-media-type="image"]:not([hidden])'
                            )
                        ).indexOf(media);
                        gallery.dispatchEvent(
                            new CustomEvent('lightbox:open', {
                                bubbles: true,
                                detail: { index: imageIndex }
                            })
                        );
                    },
                    true
                ); // Use capture to intercept before the carousel's click handler
            });
        });
    }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new ProductGalleryEnhanced());
} else {
    new ProductGalleryEnhanced();
}
